import { CHECK_EMAIL_URL, USER_URL, PRE_2FA_LOGIN_URL, LOGIN_2FA_URL } from "./config";

export interface AuthResultDto {
  auth_token: string;
}

export class ApiError extends Error {
  response: Response;
  constructor(response: Response) {
    super(`API error: ${response.status}`);
    this.response = response;
  }
}

const jsonHeaders = {
  "Content-Type": "application/json; charset=UTF-8",
};

export async function checkEmail(email: string): Promise<{ user_exists: boolean; use_captcha: boolean }> {
  const res = await fetch(CHECK_EMAIL_URL, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ email }),
  });

  if (!res.ok) throw new ApiError(res);
  return res.json();
}

export async function joinWithEmail(
  email: string,
  name: string,
  password: string,
  captchaPayload?: { action: string; siteKey: string; token: string },
): Promise<AuthResultDto> {
  const body: Record<string, unknown> = {
    name,
    password,
    username: email,
    platform: "whatsapp-lp",
    referrer: typeof window !== "undefined" ? window.location.href : "",
    requested_experiments: [],
    onBoardingPending: true,
    create_predefined_data: { lists: true, labels: true },
  };

  if (captchaPayload) {
    body.captcha_method = "google_recaptcha";
    body.captcha_params = {
      token: captchaPayload.token,
      site_key: captchaPayload.siteKey,
      action: captchaPayload.action,
    };
  }

  const res = await fetch(USER_URL, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(body),
  });

  if (!res.ok) throw new ApiError(res);
  return res.json();
}

export async function preLoginWithEmail2fa(email: string, password: string): Promise<void> {
  const res = await fetch(PRE_2FA_LOGIN_URL, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ email: email.trim(), password: password.trim() }),
  });

  if (!res.ok) throw new ApiError(res);
}

export async function loginWithEmail2fa(
  email: string,
  password: string,
  code: string,
): Promise<AuthResultDto> {
  const res = await fetch(LOGIN_2FA_URL, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ email: email.trim(), password: password.trim(), code: code.trim() }),
  });

  if (!res.ok) throw new ApiError(res);
  return res.json();
}
